// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useAuth } from "../../context/AuthContext";
// import "../../style/Perfil.css";

// export default function PadrePerfil({ id }) {
//   const { token } = useAuth();
//   const [padre, setPadre] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const API = process.env.REACT_APP_API || "http://3.236.217.225:5001/api";

//   useEffect(() => {
//     if (!token || !id) return;

//     const fetchPerfil = async () => {
//       try {
//         const { data } = await axios.get(
//           `${API}/perfiles/padre/${id}`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         setPadre(data);
//       } catch (error) {
//         console.error("❌ Error perfil padre:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPerfil();
//   }, [id, token]);

//   if (loading) return <p>Cargando perfil...</p>;
//   if (!padre) return <p>Perfil no encontrado</p>;

//   return (
//     <div className="perfil-container">
//       {padre.foto && (
//         <img
//           src={`${API}${padre.foto}`}
//           alt="Perfil"
//           className="perfil-foto"
//         />
//       )}
//       <h2>{padre.nombre} {padre.apellido}</h2>
//       <p><strong>Email:</strong> {padre.email}</p>
//       <p><strong>Rol:</strong> {padre.role}</p>
//       <p>
//         <strong>Matrículas de hijos:</strong>{" "}
//         {padre.matriculas_hijos || "Ninguna"}
//       </p>
//     </div>
//   );
// }


//

import React, { useEffect, useState } from "react";
// 1. IMPORTAMOS NUESTRA INSTANCIA Y CONFIGURACIÓN
import axios from "../../api/axiosAuth";
import { useAuth } from "../../context/AuthContext";
import { UPLOADS_URL } from "../config"; 
import "../../style/Perfil.css";

export default function PadrePerfil({ id }) {
  const { token } = useAuth();
  const [padre, setPadre] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Si no hay ID o token, no intentamos la carga
    if (!token || !id) return;

    const fetchPerfil = async () => {
      try {
        setLoading(true);
        // 2. CORREGIDO: Ruta relativa. axiosAuth ya maneja la URL base y el token
        const { data } = await axios.get(`/perfiles/padre/${id}`);
        setPadre(data);
      } catch (error) {
        console.error("❌ Error perfil padre:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPerfil();
  }, [id, token]);

  if (loading) return (
    <div className="perfil-loading">
      <p>⏳ Cargando información de perfil...</p>
    </div>
  );

  if (!padre) return (
    <div className="perfil-error">
      <p>⚠️ No se pudo cargar el perfil solicitado.</p>
    </div>
  );

  return (
    <div className="perfil-card-container">
      <div className="perfil-header-bg"></div>
      
      <div className="perfil-content">
        {/* 3. CORREGIDO: Usamos UPLOADS_URL para las fotos */}
        <div className="perfil-foto-wrapper">
          {padre.foto ? (
            <img
              src={`${UPLOADS_URL}${padre.foto}`}
              alt="Foto de perfil"
              className="perfil-foto"
            />
          ) : (
            <div className="perfil-foto-placeholder">
              {padre.nombre?.charAt(0)}{padre.apellido?.charAt(0)}
            </div>
          )}
        </div>

        <h2 className="perfil-nombre">
          {padre.nombre} {padre.apellido}
        </h2>
        
        <div className="perfil-info-grid">
          <div className="perfil-item">
            <span className="label">📧 Correo Electrónico:</span>
            <span className="value">{padre.email || "No registrado"}</span>
          </div>

          <div className="perfil-item">
            <span className="label">🔑 Rol de Usuario:</span>
            <span className="value badge-rol">{padre.role}</span>
          </div>

          <div className="perfil-item">
            <span className="label">👨‍👩‍👧‍👦 Vinculación Estudiantil:</span>
            <span className="value">
              {padre.matriculas_hijos || "Sin estudiantes vinculados"}
            </span>
          </div>
        </div>

        <div className="perfil-footer">
          <small>Información gestionada por el Sistema Barzillai</small>
        </div>
      </div>
    </div>
  );
}